import React from 'react';
import moment from 'moment';
import { makeStyles } from "@material-ui/core/styles";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "./dashboardStyle";
import DailyCardTiles from "./DailyCardTiles";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  maindiv: {
    backgroundColor: "#F0F0F0",
    margin: "0 8.5%",
    borderRadius: "15px",
    paddingBottom: "2%",
    [theme.breakpoints.only("sm")]: {
      marginLeft: "7%",
      marginRight: "7%",
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: "1%",
      marginRight: "1%",
    },
    
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "2em 2em 0",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
      padding: "1em 0 0",
    },
  },
  headerImageName: {
    display: "flex",
    alignItems: "center",
  },
  image: {
    width: "3em",
    height: "3em",
    [theme.breakpoints.only("sm")]: {
      
    },
    [theme.breakpoints.only("xs")]: {
      width: "2em",
      height: "2em",
    },
  },
  name: {
    fontWeight: "bolder",
    margin: "0 0 0 0.5em",
    color: "#464545",
    [theme.breakpoints.only("xs")]: {
        fontSize: "18px"
    },
  },  
  date: {
    margin: 0,
    [theme.breakpoints.only("xs")]: {
      fontSize: "18px",
      paddingTop: "1em"
    },
  },
  carddiv: {
    paddingLeft: "2em",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0em",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "13px",
      paddingRight: "13px",
    },
  },
}));

function DailyCard(props) {
  const classes = useStyles();
  const vendor = JSON.parse(localStorage.getItem('vendor_data'));

  return (
    <div className={classes.maindiv}>
      <div className={classes.header}>
        <div className={classes.headerImageName}>
          <AccountCircleIcon className={classes.image} />
          <h3 className={classes.name}>{vendor?.name}</h3>
        </div>
        <h3 className={classes.date}>
          Today, {moment().format("MMMM DD, YYYY")}
        </h3>
      </div>
      <div className={classes.carddiv}>
        <DailyCardTiles 
          today={props.today}
          due={props.due}
          completed={props.completed}
        />
      </div>
    </div>
  );
}

export default withStyles(dashboardStyle)(DailyCard);
